module.exports = __webpack_public_path__ + "static/nosotros_typewriter-638c1a9f62330ab81ee39e85cde29f76.jpg";